/* eslint-disable */
/*
*
* Данный сервис принимает на вход модель +  массив вхожений в данную модель любой глубины
* Возвращает булевое значение если существют  данные вхождение в модель или нет
* Данный сервис поможет если нужно строить цепочку подобную этой tour.get("resort").get("country").get('id')
* Сервис проверяет будет ли креш в данной участке кода
* если последний элемент цепочки не является моделью то его указывать не нужно
* */

import DataProxy from "@/js/common/Domain/Service/DataProxy";

// «Модель-подобный» объект: Backbone.Model, DataProxy или любой plain-class с .get()
// (напр. TourProductFactoryOptimize / TourFactoryOptimize). Для plain-моделей нельзя
// использовать _.clone(model): методы ES6-класса неперечисляемы и теряются при клоне,
// поэтому цепочку .get() проходим по самой модели (чтение не мутирует).
const isModelLike = (candidate) => candidate instanceof Backbone.Model
	|| candidate instanceof DataProxy
	|| (!!candidate && typeof candidate.get === 'function');

export default function backboneModelDeepInstanceOf({model,values}) {
	let result = isModelLike(model);
	if(values && result){
		result = values && values.length
	}

	if(result && values && values.length > 0){
		let deepModel = model;
		for (let i in values){
			let value = values[i];
			deepModel = deepModel.get(value);
			result = isModelLike(deepModel);
			if(!result) break;
		}
	}

	return result;
}